import { createContext, useContext } from 'react';
import type { Slot } from '../PaymentStructureGrid/types';

export interface GridDataValue {
    slots: Slot[];
    terms: number[];
    downPayments: number[];
}

export const DataContext = createContext<GridDataValue | undefined>(undefined);

export const useGridData = (): GridDataValue => {
    const value = useContext(DataContext);
    if (!value) {
        throw new Error('useGridData must be used within an AltDealStructureDataProvider');
    }
    return value;
};
